import type {DimensionsSpecificationRequestBody} from './DimensionsSpecificationRequestBody';

export type PatchDimensionsRequestBody = {
  dimensions?: DimensionsSpecificationRequestBody | null;
  /**
   * Vehicle operating weight in kg
   */
  operatingWeight?: number | null;
  /**
   * Vehicle weight in kg
   */
  weight?: number | null;
  /**
   * Vehicle maximum load capacity in kg
   */
  maximalLoadCapacity?: number | null;
  /**
   * Wheel base
   */
  wheelBase?: number | null;
  /**
   * Trunk space
   */
  trunkSpace?: number | null;
};
